import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'weatherIcon',
    standalone: false
})
export class WeatherIconPipe implements PipeTransform {

  public icons: WeatherIcon[] = [
    {
      code: '01d',
      icon: 'far fa-sun'
    },
    {
      code: '02d',
      icon: 'far fa-cloud-sun'
    },
    {
      code: '03d',
      icon: 'far fa-cloud'
    },
    {
      code: '04d',
      icon: 'far fa-cloud'
    },
    {
      code: '09d',
      icon: 'far fa-cloud-rain'
    },
    {
      code: '10d',
      icon: 'far fa-cloud-sun-rain'
    },
    {
      code: '11d',
      icon: 'far fa-poo-storm'
    },
    {
      code: '13d',
      icon: 'far fa-snowflake'
    },
    {
      code: '50d',
      icon: 'far fa-fog'
    },
  ];

  private newWeatherCodesMapping = {
    800: '01d',
    801: '02d',
    802: '03d',
    803: '03d',
    804: '03d',
    301: '09d',
    302: '09d',
    310: '09d',
    311: '09d',
    312: '09d',
    313: '09d',
    314: '09d',
    321: '09d',
    520: '09d',
    521: '09d',
    522: '09d',
    531: '09d',
    200: '11d',
    201: '11d',
    202: '11d',
    210: '11d',
    211: '11d',
    212: '11d',
    221: '11d',
    230: '11d',
    231: '11d',
    232: '11d',
    511: '13d',
    600: '13d',
    601: '13d',
    602: '13d',
    611: '13d',
    612: '13d',
    613: '13d',
    615: '13d',
    616: '13d',
    620: '13d',
    621: '13d',
    622: '13d',
    500: '10d',
    501: '10d',
    502: '10d',
    503: '10d',
    504: '10d',
    701: '50d',
    711: '50d',
    721: '50d',
    731: '50d',
    741: '50d',
    751: '50d',
    761: '50d',
    762: '50d',
    771: '50d',
    781: '50d',
  };

  transform(weatherIcon: string): string {
    if (!!weatherIcon) {

      if (isNaN(+weatherIcon)) {
        // replace night icon codes with day icon codes
        const weatherIconDay = weatherIcon.replace(/.$/, 'd');
        const weatherIconObject = this.icons.find(t => t.code === weatherIconDay);
        return weatherIconObject?.icon ?? '';
      } else {

        const oldCode = this.newWeatherCodesMapping[weatherIcon];
        return this.transform(oldCode);
      }
    }
    return '';
  }

}

export class WeatherIcon {
  code: string;        // https://openweathermap.org/weather-conditions
  icon: string;
}

export interface WeatherIconById {
  [key: number]: string;
}
